import React, { use, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

// do zmioany
import { setPage, setMaxPages, setSorting, setCheckedItem, toggleAddModal, toggleEditModal , toggleNeedRefresh } from '../../store/notificartionsTabSlice.js';
import {
  getHeaders,
  headerWidths,
  tabsConfig,
  buttonsConfig,
  leftSideConfig,
  rightSideConfig,
  empty,
  sortButtonsConfig,
} from './notificationsTableConfig.js';

// do koniec zmioany

import Table from '../../components/list2/table';
import Pagination from '../../components/components/pagination/pagination.jsx';
import Menu from '../../components/menu/menu';
import Content from '../../components/content/content';
import LineWithButtons from '../../components/components/line_with_buttons/lineWithButtons.jsx';
import UnisersalLineWithComponents from '../../components/components/universal_line_with_components/universalLineWithComponents.jsx';

import './Notifications.css';

import { fetchNotifications } from './notificationsTableService.js';

import AddNewNotification from './addNotification.jsx';
import EditSportModal from './editNotification.jsx';



function Notifications() {

  const dispatch = useDispatch();
  const activeTab = useSelector((state) => state.notifications.activeUsersTab);
  const totalPages = useSelector((state) => state.notifications.maxPages);
  const currentPage = useSelector((state) => state.notifications.currentPage);
  const sortBy = useSelector((state) => state.notifications.sortBy);
  const sortDirection = useSelector((state) => state.notifications.sortDirection);
  const checkedItems = useSelector((state) => state.notifications.checkedItems);
  const addModalOpen = useSelector((state) => state.notifications.addModalOpen);
  const editModalOpen = useSelector((state) => state.notifications.editModalOpen);
  const keyword = useSelector((state) => state.notifications.keyword);
  const searchValue = useSelector((state) => state.notifications.searchValue);

  const needRefresh = useSelector((state) => state.notifications.needRefresh);

  const [rowsNotif, setRowsNotif] = useState([]);
  const sortArrowColorActive = '#060606';
  const sortArrowColorInactive = '#06060650';

    // Funkcja otwierająca modal (Redux Action)
    const handleToggleAddModal = () => {
      dispatch(toggleAddModal());
    };
    const handleToggleEditModal = () => {
      dispatch(toggleEditModal());
    };

  useEffect(() => {
    fetchNotifications(
        sortBy,
        sortDirection,
        keyword,
        currentPage,
        dispatch,
        setMaxPages,
        setRowsNotif,
        checkedItems
    );

  }, [currentPage, sortBy, sortDirection, checkedItems, needRefresh]);

  const headers = getHeaders(
    sortBy,
    sortDirection,
    dispatch,
    setSorting,
    sortArrowColorActive,
    sortArrowColorInactive,
    rowsNotif,
    checkedItems);

    const paginationProps = {
      reduxSelector: (state) => state.notifications.currentPage,
      reduxAction: setPage,
      totalPages: totalPages,
      maxVisibleButtons: 5,
    };
    
    const rightSideConfig2 = [
      {
        component: Pagination, // Komponent do wyrenderowania
        props: paginationProps, // Właściwości przekazywane do komponentu
      },
    ];

  return (
    <div>
      {addModalOpen && <AddNewNotification />}
      {editModalOpen && <EditSportModal />}
      <Menu />
      <Content>
        <LineWithButtons tabs={tabsConfig(activeTab, dispatch)} buttons={buttonsConfig(handleToggleAddModal)} />
      
        <div className="table-container">          
            <UnisersalLineWithComponents leftSide={empty} rightSide={rightSideConfig(searchValue, dispatch)} />
            <Table
              headers={headers}
              rowsClass='row-sports'
              cellClass='cell-sports'
              rows={rowsNotif}
              columnWidths={headerWidths}
              idViewing={true}
              idArrayId={1}
              cellClass2='cell-center'
              cellClass2ConditionList={[1, 2, 5, 6]} />
            <UnisersalLineWithComponents leftSide={leftSideConfig(dispatch)} rightSide={rightSideConfig2} />
        </div>
      </Content>
    </div>
  );
}

export default Notifications;